export default "__VITE_ASSET__BTDfs0DB__"